import { Provider } from '@cartodb/workflows-engine'
import { API_VERSIONS, Credentials } from '@carto/react-api'
import settings from 'settings'
import { getToken } from 'features/common'
import { getClient } from 'features/common/utils/clientParameter'
import { executeSQLWithRetries } from 'features/sql/api/sql'
import { selectTempRegion } from '../../model/selectors/workflow'
import { SqlOptions } from './interface'
import { getStore } from 'app/state/storeRegistry'

export class SqlQueryExecutor {
  async #getCredentials(): Promise<Credentials> {
    return {
      apiVersion: API_VERSIONS.V3,
      accessToken: await getToken(),
      apiBaseUrl: settings.apiBaseUrl
    }
  }

  #getExecuteSqlOptions(options?: Partial<SqlOptions>) {
    const sqlOptions = {
      client: getClient(),
      headers: { 'Cache-Control': 'no-cache' }
    }

    // TODO not using WorkflowStoreManager to avoid wrong coupling of classes
    // WorkflowManager (WorkflowStoreManager) <- ReduxManager (setters & getters)
    // SqlQueryExecutor <- ReduxManager (setters & getters)
    const workflow = getStore().getState().workflows.workflow
    if (workflow?.config?.connectionProvider === Provider.BigQuery) {
      sqlOptions['bigquery.location'] = selectTempRegion(workflow)
    }

    return Object.assign(sqlOptions, options || {})
  }

  async execute<T>(
    query: string,
    connection: string,
    options?: { options?: Partial<SqlOptions>; retry?: number; signal?: AbortSignal }
  ) {
    return executeSQLWithRetries<T>({
      credentials: await this.#getCredentials(),
      query,
      connection,
      opts: {
        ...this.#getExecuteSqlOptions(options?.options),
        signal: options?.signal
      },
      retry: options?.retry
    })
  }
}
